import React from 'react';
import PropTypes from 'prop-types';

import LinkOptions from './link-options';
import EventOptions from './event-options';
import StyleOptions from './style-options';
import TooltipOption from './tooltip-option';
import SlideShowDescriptionOption from './slideshow-description-option';
import LinkTextOption from './link-text-option';
import ImagePreview from './image-preview';

import LocalizationConsumer from '../../../../l10n/localization-context';
import tabs from '../../../../constants/tabs';

const Settings = ({
  openInNewWindow,
  onLinkTextChange,
  onTooltipChange,
  onOpenInNewWindowChange,
  onLinkStyleChange,
  activeTab,
  isEventLinksToDetails,
  isEventRegistrationFormDisabled,
  tooltip,
  isLinkTextEditable,
  linkText,
  previewImage,
  onEventDestinationChange,
  isLinkTextSectionHidden,
  isLinkStyleSectionHidden,
  isTooltipOptionHidden,
  isLinkOptionsHidden,
  linkStyles,
  linkStyle,
  linkStyleIframeSrc,
  isSlideShowInsertLinksMode,
  slideShowImageDescription,
  onSlideShowImageDescriptionChange
}) => (
  <div className="-wa-edit-controls__settings">
    { (isSlideShowInsertLinksMode ||
      (isLinkTextSectionHidden &&
      isLinkStyleSectionHidden &&
      isTooltipOptionHidden &&
      isLinkOptionsHidden &&
      activeTab !== tabs.EVENTS)) ? null : (
        <div className="-wa-edit-controls__settings-header">
          <LocalizationConsumer id="insert-link-dialog.settings-section-name" />
        </div>) }

    <LinkOptions
      isHidden={isLinkOptionsHidden}
      openInNewWindow={openInNewWindow}
      onChange={onOpenInNewWindowChange}
    />
    <EventOptions
      activeTab={activeTab}
      isEventLinksToDetails={isEventLinksToDetails}
      onChange={onEventDestinationChange}
      isEventRegistrationFormDisabled={isEventRegistrationFormDisabled}
    />
    <StyleOptions
      isHidden={isLinkStyleSectionHidden}
      onChange={onLinkStyleChange}
      linkStyles={linkStyles}
      linkStyle={linkStyle}
      linkStyleIframeSrc={linkStyleIframeSrc}
    />

    <TooltipOption
      isHidden={isTooltipOptionHidden}
      tooltip={tooltip}
      onChange={onTooltipChange}
    />

    <SlideShowDescriptionOption
      isHidden={!isSlideShowInsertLinksMode}
      description={slideShowImageDescription}
      onChange={onSlideShowImageDescriptionChange}
    />

    <LinkTextOption
      isHidden={isLinkTextSectionHidden}
      onChange={onLinkTextChange}
      linkText={linkText}
      isLinkTextEditable={isLinkTextEditable}
    />

    <ImagePreview
      previewImage={previewImage}
    />
  </div>
);

Settings.propTypes = {
  onEventDestinationChange: PropTypes.func.isRequired,
  onLinkTextChange: PropTypes.func.isRequired,
  onTooltipChange: PropTypes.func.isRequired,
  onOpenInNewWindowChange: PropTypes.func.isRequired,
  onLinkStyleChange: PropTypes.func.isRequired,
  tooltip: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  activeTab: PropTypes.oneOf(Object.values(tabs)).isRequired,
  openInNewWindow: PropTypes.bool.isRequired,
  isEventLinksToDetails: PropTypes.bool.isRequired,
  isEventRegistrationFormDisabled: PropTypes.bool.isRequired,
  isLinkTextEditable: PropTypes.bool.isRequired,
  previewImage: PropTypes.string.isRequired,
  isLinkTextSectionHidden: PropTypes.bool.isRequired,
  isLinkStyleSectionHidden: PropTypes.bool.isRequired,
  isTooltipOptionHidden: PropTypes.bool.isRequired,
  isLinkOptionsHidden: PropTypes.bool.isRequired,
  linkStyles: PropTypes.arrayOf(PropTypes.string).isRequired,
  linkStyle: PropTypes.string.isRequired,
  linkStyleIframeSrc: PropTypes.string.isRequired,
  isSlideShowInsertLinksMode: PropTypes.bool.isRequired,
  slideShowImageDescription: PropTypes.string.isRequired,
  onSlideShowImageDescriptionChange: PropTypes.func.isRequired
};

export default Settings;